(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artwork-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.artwork-gallery-section').forEach(function (section) {
    var buttons = section.querySelectorAll('.artwork-gallery__filter');
    var items = section.querySelectorAll('.artwork-gallery__item');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');

        var filter = button.dataset.filter;

        items.forEach(function (item) {
          var show = filter === 'all' || item.dataset.type === filter;
          item.hidden = !show;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-artwork-post"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-back-to-gallery]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var galleryPath = link.pathname;
      var referrerPath = document.referrer ? new URL(document.referrer).pathname : '';

      // Only replay history when we actually came from the gallery page itself.
      // A language switch reloads the current article at the same path, which would
      // otherwise make history.back() return to the article instead of the gallery.
      if (referrerPath === galleryPath && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'newsletter-popup-dismissed';

    var popup = document.getElementById('newsletter-popup');
    if (!popup) return;

    /* --- Nieuwsbriefformulier lenen van de footer -------------------------
       Brevo koppelt z'n JS aan precies één #sib-form per pagina (de footer).
       We verplaatsen dat live element in de popup als hij opengaat en zetten
       het exact terug op z'n plek als hij dichtgaat. Zo blijft er altijd maar
       één #sib-form op de pagina en werkt het formulier op beide plekken. */
    var slot = popup.querySelector('[data-newsletter-slot]');
    var borrowed = null;
    var anchor = null;

    function borrowForm() {
      if (!slot || borrowed) return;
      var form = document.querySelector('.rf-newsletter-embed:not(.rf-newsletter-embed--iframe)');
      if (!form || slot.contains(form)) return;
      anchor = document.createComment('rf-newsletter-embed');
      form.parentNode.insertBefore(anchor, form);
      slot.appendChild(form);
      borrowed = form;
    }

    function returnForm() {
      if (borrowed && anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(borrowed, anchor);
        anchor.parentNode.removeChild(anchor);
      }
      borrowed = null;
      anchor = null;
    }

    popup.addEventListener('dialog:open', borrowForm);
    popup.addEventListener('dialog:close', returnForm);

    /* --- Automatisch tonen na de ingestelde vertraging ------------------- */
    if (localStorage.getItem(STORAGE_KEY)) return;

    // Bezoekers uit advertenties (utm/fbclid/gclid in de link) krijgen de popup deze
    // sessie niet: zij komen voor één aanbod, de popup leidt dan alleen af.
    if (popup.dataset.hideForAds === 'true') {
      var AD_KEY = 'rf-ad-visit';
      try {
        if (/[?&](utm_source|utm_medium|utm_campaign|fbclid|gclid|ttclid)=/.test(window.location.search)) {
          sessionStorage.setItem(AD_KEY, '1');
        }
        if (sessionStorage.getItem(AD_KEY)) return;
      } catch (e) {}
    }

    var delay = (parseInt(popup.dataset.delay, 10) || 5) * 1000;

    function markDismissed() {
      localStorage.setItem(STORAGE_KEY, '1');
    }

    popup.addEventListener('dialog:close', markDismissed);

    customElements.whenDefined('dialog-component').then(function () {
      setTimeout(function () {
        if (!localStorage.getItem(STORAGE_KEY) && typeof popup.showDialog === 'function') {
          borrowForm();
          popup.showDialog();
        }
      }, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
